import { PdfTemplatePage } from "Components/PdfTemplate/PdfTemplatePage";
import { PdfTemplatePageSection } from "Components/PdfTemplate/PdfTemplatePageSection";
import { PdfTemplateGoalFulfillment } from "Components/PdfTemplate/pages/PdfTemplateGoalFulfillment";
import { PdfTemplatePortfolio } from "Components/PdfTemplate/pages/PdfTemplatePortfolio";

export const PdfTemplateContentPage = () => {
  return (
    <PdfTemplatePage>
      <PdfTemplatePageSection>
        <PdfTemplateGoalFulfillment />
      </PdfTemplatePageSection>
      <PdfTemplatePageSection>
        <PdfTemplatePortfolio />
      </PdfTemplatePageSection>
    </PdfTemplatePage>
  );
};
